import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &.has-image{
    justify-content: flex-start;
  }
`

interface Props {
  holidayType: string
  destination: string
  hasImage: boolean
}

export function ResultsFilteredByHolidayTypeAndDestination({ holidayType, destination, hasImage }: Props) {
  return (
    <Container className={cn({ 'has-image': hasImage })}>
      <Heading as="span" colour="neutral-eight" variant="heading1">
        <i>{holidayType}</i>&nbsp;
        travel inspiration&nbsp;
        in&nbsp;
        <i>{destination}</i>
      </Heading>
    </Container>
  )
}
